import { ActivityId } from "@sp-crm/core";
import { trpc } from "components/rpc/trpc";
import React from "react";
import { Redirect, useParams } from "react-router";
import { useQuery } from "@tanstack/react-query";

export const ActivityRedirect: React.FC = () => {
    const { activityId } = useParams<{ activityId: string }>();
    const trpcClient = trpc.useTRPC();
    const { data, isLoading } = useQuery(
        trpcClient.activity.parentAppLink.queryOptions({
            activityId: activityId as ActivityId,
        }),
    );

    if (isLoading) {
        return null;
    }

    return <Redirect to={data ?? "/"} />;
};
